import { AutoMap } from "@automapper/classes";
import { MaterielCompresseurDTO } from "./materiel-compresseur.dto";

export class MaterielAdductionDTO {
    @AutoMap()
    type!: number;
    @AutoMap()
    fabricant!: string;
    @AutoMap()
    description!: string;
    @AutoMap()
    reference!: string;
    @AutoMap()
    materielCompresseur: MaterielCompresseurDTO = new MaterielCompresseurDTO();
}